<template>
  <div v-if="buttons.length" class="section-detailed-review pb-40">
    <h2 class="heading-4-bd mb-12">Reviews from Past Travellers</h2>
    <div class="flex mb-16">
      <DJButton
        v-for="(button, index) in buttons"
        class="mr-8"
        :key="index"
        :type="sectionActive === button.id ? 'accent' : 'tertiary'"
        rounded
        @click.prevent="handleChangeSection(button.id)"
      >
        <span class="text-md-sb mb-text-sm-sb">{{ button.label }}</span>
      </DJButton>
    </div>
    <SectionReviewDestination
      ref="sectionReviewDestinationRef"
      v-show="sectionActive === SectionType.Destination"
      :designer="designer"
      :country-ids="countryIds"
    />
    <SectionReviewDesigner ref="sectionReviewDesignerRef" v-show="sectionActive === SectionType.Designer" :designer="designer" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import DJButton from '~/components/ui/button/Button.vue'
import { isEmpty } from '~/helper'
import SectionReviewDesigner from './SectionReviewDesigner.vue'
import SectionReviewDestination from './SectionReviewDestination.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

enum SectionType {
  Destination,
  Designer,
}

const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const designer = computed(() => tripPlanStore.designer)
const countryIds = computed(() => {
  if (isEmpty(dataTrip.value)) return []
  return dataTrip.value?.country_ids || []
})

const sectionActive = ref<SectionType>(SectionType.Destination)
const buttons = ref([
  { id: SectionType.Destination, label: 'Destination Reviews' },
  { id: SectionType.Designer, label: 'Local Designer Reviews' },
])
const sectionReviewDestinationRef = ref<InstanceType<typeof SectionReviewDestination> | null>(null)
const sectionReviewDesignerRef = ref<InstanceType<typeof SectionReviewDesigner> | null>(null)
const reviewsLocalDesigner = computed(() => sectionReviewDesignerRef.value?.reviews || [])
function handleChangeSection(section: SectionType) {
  sectionActive.value = section
}
watch(
  () => sectionReviewDestinationRef.value?.reviews,
  (value) => {
    if (value) {
      if (!value.total) {
        buttons.value = buttons.value.filter((button) => button.id !== SectionType.Destination)
        sectionActive.value = SectionType.Designer
      }
    }
  },
  { deep: true },
)
watch(
  () => sectionReviewDesignerRef.value?.reviews,
  (value) => {
    if (value) {
      if (!value.total) {
        buttons.value = buttons.value.filter((button) => button.id !== SectionType.Designer)
        sectionActive.value = SectionType.Destination
      }
    }
  },
  { deep: true },
)

defineExpose({
  reviewsLocalDesigner,
})
</script>

<style lang="scss" scoped></style>
